import { post, get, deleteMethod } from '@/utils/http';

const BASE_URL = process.env.VUE_APP_API_BASE_URL_COMICS;

export function login() {
  return post(`${BASE_URL}/authorizations/guest`, {}, {});
}

export function refresh() {
  return post(`${BASE_URL}/authorizations/refresh`);
}

export function refreshToken() {
  return post(`${BASE_URL}/authorizations/refresh`);
}

export function auth(data) {
  return post(`${BASE_URL}/socials/firebase/authorizations`, data);
}

export function getUser() {
  return get(`${BASE_URL}/user`);
}

export function getProducts() { // 获取充值套餐列表
  return get(`${BASE_URL}/products`);
}

export function getVip() { // 获取VIP套餐列表
  return get(`${BASE_URL}/product/vip`);
}

export function getBalanceRecord(data) { // 获取消费记录
  return get(`${BASE_URL}/balance-log`, data);
}

export function getTask() { // 获取签到任务列表
  return get(`${BASE_URL}/tasks`);
}

export function checkIn() { // 签到
  return post(`${BASE_URL}/check-in`);
}

export function getCheckInHistory() { // 获取签到历史
  return get(`${BASE_URL}/check-in/history`);
}

export function getHome() {
  return get(`${BASE_URL}/store/home`);
}

export function getNovelChapters(id) {
  return get(`${BASE_URL}/novels/${id}/chapters`);
}

export function getChapterDetail(novelId, chapterId) {
  return get(`${BASE_URL}/novels/${novelId}/chapters/${chapterId}`);
}

export function getNovelDetail(id) {
  return get(`${BASE_URL}/novels/${id}`);
}

export function getChannels() {
  return get(`${BASE_URL}/store/channels`);
}

export function getHomeChannel() { // 首页栏目
  return get(`${BASE_URL}/home/channel`);
}

export function getHomeChannelData(id) { // 根据对应栏目获取首页展示数据
  return get(`${BASE_URL}/home/channel/${id}/novels`);
}

export function getChannelData(id, params) { // 根据对应栏目获取展示数据
  return get(`${BASE_URL}/home/${id}/novels`, params);
}

export function getVipSuggest() { // 获取vip推荐漫画列表
  return get(`${BASE_URL}/home/vipsuggest`);
}

export function feedBack(data) { // feedback
  return post(`${BASE_URL}/feedback`, data);
}

export function pixel(params) { // 初始化像素跟踪
  return post(`${BASE_URL}/pixel/initialize`, {}, params);
}

export function addFavorite(novelId) {
  return post(`${BASE_URL}/bookshelves`, { novel_id: novelId });
}

export function deleteFavorite(novelId) {
  return deleteMethod(`${BASE_URL}/bookshelves/novels/${novelId}`);
}

export function searchNovel(params) {
  return get(`${BASE_URL}/search/novels`, params);
}

export function getSearchRecommend() {
  return get(`${BASE_URL}/search/recommend`);
}

export function getSysConfig() {
  return get(`${BASE_URL}/system/config`);
}

export function getShelfBooks() {
  return get(`${BASE_URL}/bookshelves`);
}

export function removeShelfBooks(ids) {
  return post(`${BASE_URL}/bookshelves/remove${BASE_URL}`, { bookshelf_ids: ids });
}

export function unlockChapter(nId, cId) {
  return post(`${BASE_URL}/novels/${nId}/chapters/${cId}`, {
    'unlock_confirmed': true,
    'unlock_mode': 2,
  });
}
export function unlockNovels(nId) {
  return post(`${BASE_URL}/novels/${nId}/chapters/bulk-unlock`, {
    'unlock_confirmed': true,
    'unlock_mode': 2,
  });
}

export function cardValidate(data) { // 校验信用卡
  return post(`${BASE_URL}/payment/validate-card`, data);
}

export function pay(data) { // 支付
  return post(`${BASE_URL}/payment/moo/direct`, data);
}

export function getPremiumDetail() {
  return get(`${BASE_URL}/product/details`);
}
